export default __webpack_public_path__ + "static/MD_SearchThumb_Cloud_Management-c7ab80440e9749b9d831bab113595b32.webp";